import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IconMaterial',
  props: {
  icon: { type: String, default: '' },
  color: { type: String, default: '' },
  size: { type: [Number, String], default: '' },
  variant: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const className = computed(() => {
  switch (props.variant) {
    case 'outlined':
      return 'material-icons-outlined';
    case 'rounded':
      return 'material-icons-rounded';
    case 'sharp':
      return 'material-icons-sharp';
    case 'twotone':
      return 'material-icons-two-tone';
    default:
      return '';
  }
});

const iconName = computed(() => {
  return `md:${props.icon}`;
});

const __returned__ = { props, className, iconName }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})